module.exports = __webpack_public_path__ + "img/311.085c507c.svg";